module.exports = __webpack_public_path__ + "img/bg_honor_desk_4.ff609c4f.png";